import { render, staticRenderFns } from "./finish-gr.vue?vue&type=template&id=54d83212&scoped=true"
import script from "./finish-gr.vue?vue&type=script&lang=js"
export * from "./finish-gr.vue?vue&type=script&lang=js"
import style0 from "./finish-gr.vue?vue&type=style&index=0&id=54d83212&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d83212",
  null
  
)

export default component.exports